module.exports = __webpack_public_path__ + "img/iconos-02.61144b2a.png";